import {
  Alert,
  IconFolderLine,
  IconOpenFolderLine,
  ToggleGroup,
  View,
} from "@instructure/ui";
import { useTranslation } from "react-i18next";
import { useContext, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { CourseService } from "../../../../services/CourseService";
import {
  ERROR,
  useNotification,
} from "../../../CustomHooks/NotificationProvider";
import { isArchived, sortOutcomes } from "../../../LearningOutcomes/utils";
import OfferingHeader from "../OfferingHeader";
import { OutcomesContext } from "../Review";
import ApprovedOutcomeToggle from "./ApprovedOutcomeToggle";
import CLOArchiveToggle from "./CLOArchiveToggle";
import UnapprovedOutcomeToggle from "./UnapprovedOutcomeToggle";

const OfferingToggle = ({
  offering,
  course,
  setNumUnapprovedOutcomes,
  handleArchiveOutcome,
}) => {
  const { t } = useTranslation();
  const { qcEnabled } = useContext(OutcomesContext);
  const showNotification = useNotification();
  const [loadingOutcomes, setLoadingOutcomes] = useState(false);
  const archivedClos = sortOutcomes(
    offering.learning_outcomes.filter((lo) => isArchived(lo))
  );
  const currentClos = sortOutcomes(
    offering.learning_outcomes.filter((lo) => !isArchived(lo))
  );

  const refreshLOs = async () => {
    try {
      setLoadingOutcomes(true);
      const outcomes = await CourseService.getContextOutcomes(
        offering.id,
        qcEnabled,
        null,
        true,
        offering.course_summary.parent_course_id
      );
      offering.learning_outcomes = outcomes;
    } catch {
      showNotification(t("notifications.analyze.outcomesLoadError"), ERROR);
    } finally {
      setLoadingOutcomes(false);
    }
  };

  return (
    <ToggleGroup
      iconExpanded={IconOpenFolderLine}
      icon={IconFolderLine}
      defaultExpanded
      toggleLabel={`${t("global.showingData")} ${offering.code}`}
      summary={
        <OfferingHeader
          course={course}
          offering={offering}
          subject={offering.course_summary.academic_subject.title}
        />
      }
      size="small"
      margin="0 0 small 0"
    >
      <View display="block" padding="small">
        {loadingOutcomes ? (
          <Skeleton
            count={3}
            style={{ height: 46, borderRadius: 5, marginBottom: 15 }}
          />
        ) : currentClos.filter(
            (outcome) =>
              !outcome.context_maps ||
              outcome.context_maps.find((cm) => cm.context_id === offering.id)
          ).length === 0 ? (
          <Alert variant="info">{t("analyze.noOutcomes")}</Alert>
        ) : (
          <>
            {currentClos
              .filter(
                (outcome) =>
                  !outcome.context_maps ||
                  outcome.context_maps.find(
                    (cm) => cm.context_id === offering.id
                  )
              )
              .map((outcome) =>
                outcome.unapproved ? (
                  <UnapprovedOutcomeToggle
                    key={outcome.id}
                    outcome={outcome}
                    course={course}
                    offering={offering}
                    refreshLOs={refreshLOs}
                    setNumUnapprovedOutcomes={setNumUnapprovedOutcomes}
                  />
                ) : (
                  <ApprovedOutcomeToggle
                    key={outcome.id}
                    outcome={outcome}
                    offering={offering}
                    refreshLOs={refreshLOs}
                    handleArchiveOutcome={handleArchiveOutcome}
                  />
                )
              )}
            {archivedClos.length > 0 && (
              <CLOArchiveToggle
                offering={offering}
                archivedClos={archivedClos}
              />
            )}
          </>
        )}
      </View>
    </ToggleGroup>
  );
};

export default OfferingToggle;
